const TIINA_TOHU = "/tiina-t-mark.png";

// Fixed watermark using the T mark in olive green
export function TohuWatermarkFixed() {
  return (
    <div
      className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8 lg:bottom-12 lg:right-12 z-40 pointer-events-none select-none"
      aria-hidden="true"
      data-testid="tohu-watermark"
    >
      <div className="w-32 h-32 sm:w-56 sm:h-56 lg:w-80 lg:h-80 rounded-full flex items-center justify-center overflow-hidden" style={{ backgroundColor: "rgba(72,94,35,0.12)" }}>
        <img
          src={TIINA_TOHU}
          alt=""
          className="w-[85%] h-[85%] object-contain opacity-[0.5]"
        />
      </div>
    </div>
  );
}
